// Phone formatting utility
export function formatPhoneNumber(number) {
  if (!number) return '';
  // Remove all non-digit characters
  let cleaned = number.replace(/\D/g, '');
  // Remove leading country code if present
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    cleaned = cleaned.slice(1);
  }
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0,3)}) ${cleaned.slice(3,6)}-${cleaned.slice(6)}`;
  }
  return number;
} 